var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"profile-layout"},[_c('div',{staticClass:"customer-profile"},[_c('customer-profile',{on:{"showInvalidFormError":_vm.showInvalidFormError}})],1),_c('error-message',{attrs:{"errorText":_vm.errorMessage},on:{"close":function($event){_vm.errorMessage = ''}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }